<template>
    <div id="app">
        <!-- <div>{{iOSInfo}}1234556</div> -->
        <router-view/>
    </div>
</template>
<script>
import service from './util/network'

export default {
    data() {
        return {
            iOSInfo: '',
            test7777: '',
        }
    },

    mounted() {
        //解析url方法
        function getUrlCode(name) {
            return (
                decodeURIComponent(
                    (new RegExp(
                        '[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)'
                    ).exec(location.href) || [, ''])[1].replace(/\+/g, '%20')
                ) || null
            )
        }

        //设置请求参数
        let device = getUrlCode('device')
        console.log('App', getUrlCode('device'))
        if (device) {
            localStorage.setItem('device', device)
            service.defaults.headers.device = device
        } else {
            localStorage.setItem('device', 'ios')
            service.defaults.headers.device = 'ios'
        }
        console.log('app2', localStorage.getItem('device'))

        let version = getUrlCode('version')
        if (version) {
            localStorage.setItem('version', version)
            service.defaults.headers['S-version'] = version
        }

        let xxxtoken = getUrlCode('token')
        localStorage.setItem('xxxxtoken', "");
        if (xxxtoken) {
            localStorage.setItem('xxxxtoken', xxxtoken)
            let token = xxxtoken.split('').reverse().join('')
            service.defaults.headers['S-token'] = token
        }

        let uniapp = getUrlCode('uniapp');
        localStorage.setItem('uniapp', uniapp);
        if (uniapp) {
            let script = document.createElement("script");
            script.src = "https://shengjin.oss-cn-hangzhou.aliyuncs.com/weizhen/common/javascript/uni.webview.1.5.6.js";
            document.body.appendChild(script);
            script.onload = () => {
                console.log("加载uniapp webview文件")
            }
        }

        $bus.$on("saveToken", (token) => {
            localStorage.setItem('xxxxtoken', token)
            service.defaults.headers['S-token'] = xxxtoken.split('').reverse().join('');
        })

        // this.iOSInfo = localStorage.getItem('token')
        // this.test7777 = localStorage.getItem('test7777')
    },
}
</script>
<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    color: #2c3e50;
    margin: 0;
    padding: 0;
    height: 100vh;
    user-select: none;
}

a,
a:link,
a:visited,
a:hover,
a:active {
    text-decoration: none;
    color: inherit;
}

@media screen and (max-width: 630px) {
    #app {
        font-size: calc(100vw / 23.4375) !important;
        overflow: overlay;
    }
}
</style>
